import './footer.css'
const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="service-locations">
          <p style={{color: "#555", fontSize: "0.85rem", margin: 0}}>
            <strong style={{color: "#333"}}>Service Areas:</strong> Sunshine | Werribee | Melbourne | Parkville | Truganina | Point Cook | Hoppers Crossing | Williams Landing
          </p>
        </div>

        <h3>Follow Us</h3>
        
        <div className="social-review-wrapper">
          <div className="social-links">
            <a href="https://www.facebook.com/profile.php?id=61564371279887" title="facebook" target="_blank"  rel="noreferrer" >
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/nikselitecleaning_au?igsh=MXVjMWdocHMyeDJsZQ%3D%3D&utm_source=qr" target="_blank" rel="noreferrer" title="instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          
          <div className="review-container">
            <div className="review">
              <a href="https://g.co/kgs/EXHKKS8" target="_blank"  rel="noreferrer">Write a Review</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer